import Link from 'next/link'
import { EyebrowMD, HeadingXS } from '@/atoms/Text'
import { paths } from '@/constants'
import { useTranslate } from '@/utils/translate/translate-client'
import { HowItWorksCard } from './HowItWorksCard'

export const HowItWorksSection = () => {
  const { t } = useTranslate('guild-create')

  const cards = [
    {
      title: t('howItWorksTitle1', 'The Guild Votes'),
      description: (
        <>
          {t(
            'howItWorksDescription1',
            'Every film and concept video (called a Torch) submitted to Angel Studios is voted on by the Angel Guild.',
          )}
          <br />
          <br />
          <Link href={paths.filmmakers.index} className="text-angel-blue underline" target="_blank">
            {t('whatIsTheAngelGuild', 'What is the Angel Guild?')}
          </Link>
        </>
      ),
    },
    {
      title: t('howItWorksTitle2', 'Due Diligence'),
      description: t(
        'howItWorksDescription2',
        'When a Torch or film passes the minimum Guild voting standards, the filmmaker enters a due diligence process with Angel to discuss distribution.',
      ),
    },
    {
      title: t('howItWorksTitle3', 'Distribution with Angel'),
      description: t(
        'howItWorksDescription3',
        'After agreeing to a distribution partnership, the filmmaker works with Angel in securing funding (if needed),  growing the audience, refining the production, and distribution.',
      ),
    },
  ]

  const title = t('whatHappensOnceISubmit', 'What Happens Once I Submit?')

  return (
    <div className="flex w-full flex-col items-center bg-gray-100 px-6 py-10 lg:py-20">
      <EyebrowMD weight="semibold" className="mb-2 text-center">
        {t('howItWorks', 'How it works')}
      </EyebrowMD>
      <HeadingXS weight="bold" className="text-center">
        {title}
      </HeadingXS>
      <div className="mt-6 flex flex-col items-stretch gap-5 lg:flex-row lg:gap-10">
        {cards.map((card, index) => (
          <HowItWorksCard key={index} index={index} title={card.title} description={card.description} />
        ))}
      </div>
    </div>
  )
}
